import { NavigationDirection } from '@noths/polaris-client-ribbons-design-system';
import { createAction, createSlice, SerializedError } from '@reduxjs/toolkit';

import { addCrossSellProductToBasket, removeCrossSellProductFromBasket } from 'src/redux/basket';
import { logger } from 'src/utils';

export interface CrossSellCarouselState {
  isOpen: boolean;
  error: SerializedError | null;
  addedCardIds: number[];
  pendingCardId: null | number;
}

export interface CloseModalPayload {
  isNavigatingToCart?: boolean;
}

export const initialState: Readonly<CrossSellCarouselState> = {
  isOpen: false,
  error: null,
  addedCardIds: [],
  pendingCardId: null,
};

const {
  actions: reducerActions,
  reducer,
  name,
} = createSlice({
  name: 'crossSellModal',
  initialState,
  reducers: {
    closeModal: (state) => {
      state.isOpen = false;
    },
    openModal: (state) => {
      state.isOpen = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCrossSellProductToBasket.pending, (state, action) => {
        state.error = null;
        state.pendingCardId = action.meta.arg;
      })
      .addCase(addCrossSellProductToBasket.fulfilled, (state, { payload }) => {
        state.addedCardIds = [...state.addedCardIds, payload];
        state.error = null;
        state.pendingCardId = null;
      })
      .addCase(addCrossSellProductToBasket.rejected, (state, { error }) => {
        logger.error('Error adding cross sell card to basket', error);

        state.error = error;
        state.pendingCardId = null;
      })
      .addCase(removeCrossSellProductFromBasket.pending, (state, action) => {
        state.error = null;
        state.pendingCardId = action.meta.arg;
      })
      .addCase(removeCrossSellProductFromBasket.fulfilled, (state, { payload }) => {
        state.addedCardIds = state.addedCardIds.filter((cardId) => cardId !== payload);
        state.error = null;
        state.pendingCardId = null;
      })
      .addCase(removeCrossSellProductFromBasket.rejected, (state, { error }) => {
        logger.error('Error removing cross sell card from basket', error);

        state.error = error;
        state.pendingCardId = null;
      });
  },
});

const actions = {
  ...reducerActions,
  onCarouselSwipe: createAction<NavigationDirection>(`${name}/carouselSwipe`),
  onContinueToCart: createAction(`${name}/continueToCart`),
};

export { actions, reducer };
